import React, {useRef} from 'react';
import {isMobile} from "../components/commonmethod/CommonMethod";
import {useMobileViewport} from "../hooks/useMobileViewport";
import {topMenuIcons} from "./topMenuIcons";

function TopMenu({menus, routeTopMenuId = "", openedTopMenuId = "", clicked, setClicked, onMenuClick, onCloseDrawer}) {
    const clickRef = useRef(null);
    const isMobileViewport = useMobileViewport();
    const hideSettingsMenu = isMobile || isMobileViewport;

    const visibleMenus = hideSettingsMenu
        ? (menus ?? []).filter((item) => item.name !== "환경설정")
        : menus;

    const getMenuItemClasses = (id) => {
        const idStr = String(id);
        const classes = ["top-menu-icon", "stroke", "relative"];
        if (routeTopMenuId && idStr === String(routeTopMenuId)) {
            classes.push("is-route-active");
        }
        if (openedTopMenuId && idStr === String(openedTopMenuId)) {
            classes.push("is-opened");
        }
        return classes.join(" ");
    };

    const menuIncons = topMenuIcons;


    const menuClickListener = (id) => {
        if (onMenuClick) {
            onMenuClick(id);
        } else {
            setClicked(id);
            localStorage.setItem("topMenuId", id);
        }
    };
    return (
        <div className="topMenu py-7 bg-themeDark" ref={clickRef}>
            <ul className={'topMenu-ul '}>
                <li
                    className="top-menu-icon stroke not-hover close cursor-pointer"
                    onClick={() => onCloseDrawer?.()}
                    role="button"
                    aria-label="사이드바 닫기"
                >
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width={34} height={34} viewBox="0 0 24 24" fill="none"
                             stroke="currentColor" strokeWidth="1"
                             strokeLinecap="round" strokeLinejoin="round">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                            <path d="M11 7l-5 5l5 5"/>
                            <path d="M17 7l-5 5l5 5"/>
                        </svg>
                    </div>
                </li>

                {visibleMenus?.length > 0 && (
                    <>
                        {visibleMenus.map((item, index) => (
                                <li
                                    id={item.eng}
                                    key={`menu-${index}`}
                                    className={getMenuItemClasses(item.id)}
                                    onClick={() => {
                                        menuClickListener(item.id);
                                    }}
                                >
                                    {menuIncons[item.icon]}
                                    <p>{item.name}</p>
                                </li>
                            ))
                        }
                    </>
                )}

            </ul>
        </div>
    );
}

export default TopMenu;